export function escapeRegExp(string) {
	if (string == undefined || typeof string != 'string') {
		return string;
	}
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
